define([
	"dojo/_base/declare",
	"./Dimension2SizesSwitchboard"
], function(declare,Dimension2SizesSwitchboard) {

	return declare(Dimension2SizesSwitchboard, {
		switchboardPath: "Child:IncrementDimension2Sizes"
	});
});